import configureSubscriptionManager from './configure-subscription-manager';

export default {
  configureSubscriptionManager,
};
